import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-post-filters',
  templateUrl: './post-filters.component.html',
  styleUrls: ['./post-filters.component.scss']
})
export class PostFiltersComponent {
constructor(private uiStateService: UiStateService){}

  currentDateRange:any
  libraryDateRange:any
  dashboardStatsDateRange:any
  platforms={
    isGoogleON:false,
    isLinkedinON:false,
    isFacebookON:false,
    isInstagramON:false
  }
  postTypes:any={
    isPlanned:false,
    isPosted:false,
    isDraft:false,
    isFailed:false
  }
  @Input() dashboardSource: string = ''
  @Input() dashboard: boolean = false;
  @Input() isRouteOnDashboard: boolean = false;
  subscriptions: Subscription[] = [];
  lsData:any;
  ngOnInit(){
    const lsString= localStorage.getItem(environment.sessionData)
    if(lsString) this.lsData = JSON.parse(lsString)

     
    this.subscriptions.push( this.uiStateService.dateRangeUpdate$.subscribe((data) => {
      this.currentDateRange = data;
      if(this.isRouteOnDashboard){
        this.dashboardStatsDateRange = data;
      }
      else{
        this.libraryDateRange = data;
      }
    }));

    this.subscriptions.push( this.uiStateService.pageStatsdateRangeUpdate$.subscribe((data) => {
      // console.log("[POST FILTERS] page stats date range updated",data,"this.currentDateRange", this.currentDateRange )
      this.dashboardStatsDateRange = data;  
     
    }));

    this.subscriptions.push(this.uiStateService.platformsFilterUpdated$.subscribe((data) => {
      this.platforms = {...data}
    }))
    
    this.subscriptions.push(this.uiStateService.postTypesUpdated$.subscribe((data) =>{
      this.postTypes = data
    }))

    if(this.isRouteOnDashboard){
      switch(this.dashboardSource){
        case 'linkedin':this.platforms={isLinkedinON:true,isGoogleON:false,isFacebookON:false,isInstagramON:false}; break;
        case 'facebook':this.platforms={isLinkedinON:false,isGoogleON:false,isFacebookON:true,isInstagramON:false}; break;
        case 'instagram':this.platforms={isLinkedinON:false,isGoogleON:false,isFacebookON:false,isInstagramON:true}; break;
        case 'google':this.platforms={isLinkedinON:false,isGoogleON:true,isFacebookON:false,isInstagramON:false}; break;
      }

    }
    else{

      this.updatePlatforms(this.platforms)
    }
  }

  // getSelectedDateRange() {
  //   console.log("this.currentDateRange",this.currentDateRange,"lsDate")
  //   const startDate = this.currentDateRange?.startDate ? new Date(this.currentDateRange?.startDate) : null;
  //   const endDate = this.currentDateRange?.endDate ? new Date(this.currentDateRange?.endDate) : null;
  
  //   if (startDate && endDate) {
  //     return `${startDate.getDate().toString().padStart(2, "0")}/${(startDate.getMonth() + 1).toString().padStart(2, "0")}/${startDate.getFullYear()} - ${endDate.getDate().toString().padStart(2, "0")}/${(endDate.getMonth() + 1).toString().padStart(2, "0")}/${endDate.getFullYear()}`;
  //   }
  
  //   return 'Invalid date range';  // Optional: handle the case where the date is invalid or missing
  // }
 
   getLibraryDateRange() {
    // console.log("lsData",this.lsData.filterData.dateRange)
     this.lsData = JSON.parse(localStorage.getItem(environment.sessionData) || '{}');
    this.libraryDateRange = this.lsData.filterData.dateRange
    const startDate = this.libraryDateRange?.startDate ? new Date(this.libraryDateRange?.startDate) : null;
    const endDate = this.libraryDateRange?.endDate ? new Date(this.libraryDateRange?.endDate) : null;
  
    if (startDate && endDate) {
      return `${startDate.getDate().toString().padStart(2, "0")}/${(startDate.getMonth() + 1).toString().padStart(2, "0")}/${startDate.getFullYear()} - ${endDate.getDate().toString().padStart(2, "0")}/${(endDate.getMonth() + 1).toString().padStart(2, "0")}/${endDate.getFullYear()}`;
    }
  
    return 'Invalid date range';  // Optional: handle the case where the date is invalid or missing
  }
   getDashboardDateRange() {
    this.lsData = JSON.parse(localStorage.getItem(environment.sessionData) || '{}');
    this.dashboardStatsDateRange = this.lsData.filterData.pageStatsdateRange
    if(this.dashboardStatsDateRange.hasOwnProperty('startDate')){
      this.dashboardStatsDateRange.pageStatsstartDate = this.dashboardStatsDateRange.startDate
      this.dashboardStatsDateRange.pageStatsendDate = this.dashboardStatsDateRange.endDate
      delete this.dashboardStatsDateRange.startDate
      delete this.dashboardStatsDateRange.endDate
    }
    // console.log("[POST FILTERS] this.dashboardStatsDateRange",this.dashboardStatsDateRange,"dashboard",this.lsData.filterData.pageStatsdateRange)
    const startDate = this.dashboardStatsDateRange?.pageStatsstartDate ? new Date(this.dashboardStatsDateRange?.pageStatsstartDate) : null;
    const endDate = this.dashboardStatsDateRange?.pageStatsendDate ? new Date(this.dashboardStatsDateRange?.pageStatsendDate) : null;
  
    if (startDate && endDate) {
      return `${startDate.getDate().toString().padStart(2, "0")}/${(startDate.getMonth() + 1).toString().padStart(2, "0")}/${startDate.getFullYear()} - ${endDate.getDate().toString().padStart(2, "0")}/${(endDate.getMonth() + 1).toString().padStart(2, "0")}/${endDate.getFullYear()}`;
    }
  
    return 'Invalid date range';  // Optional: handle the case where the date is invalid or missing
  }
  updatePlatforms(value:any){
    switch(value.toString().toLocaleLowerCase()){
      case "linkedin":
        this.platforms.isLinkedinON = !this.platforms.isLinkedinON
        break;
        case "google":
          this.platforms.isGoogleON = !this.platforms.isGoogleON
          break;
        case "facebook":
          this.platforms.isFacebookON = !this.platforms.isFacebookON
          break;
        case "instagram":
          this.platforms.isInstagramON = !this.platforms.isInstagramON
          break;
    }
    if(this.isRouteOnDashboard ){
      // console.log(this.curre)
      switch(this.dashboardSource){
        case 'linkedin':this.platforms={isLinkedinON:true,isGoogleON:false,isFacebookON:false,isInstagramON:false}; break;
        case 'facebook':this.platforms={isLinkedinON:false,isGoogleON:false,isFacebookON:true,isInstagramON:false}; break;
        case 'instagram':this.platforms={isLinkedinON:false,isGoogleON:false,isFacebookON:false,isInstagramON:true}; break;
        case 'google':this.platforms={isLinkedinON:false,isGoogleON:true,isFacebookON:false,isInstagramON:false}; break;
      }
    }
    // console.log(this.platforms)
    this.uiStateService.updatePlatformsFilter(this.platforms);
  }

  updatePostType(value:any){
    
    if(this.isRouteOnDashboard) {
      this.postTypes={isPosted:this.postTypes.isPosted,isPlanned:this.postTypes.isPlanned}
    }
    switch(value.toString().split('.')[1]){
      case "planned":
          this.postTypes.isPlanned = !this.postTypes.isPlanned
          this.postTypes.isPosted = !this.postTypes.isPosted && !this.postTypes.isPlanned ? true : this.postTypes.isPosted // allow only one of planned/posted to be false at a time
        break;
      case "posted":
          this.postTypes.isPosted = !this.postTypes.isPosted
          this.postTypes.isPlanned = !this.postTypes.isPlanned && !this.postTypes.isPosted ? true : this.postTypes.isPlanned // allow only one of planned/posted to be false at a time
        break;
      case "draft":
          this.postTypes.isDraft  = !this.postTypes.isDraft
        break;
      case "failed":
          this.postTypes.isFailed  = !this.postTypes.isFailed
      break;
        
    }
    //make sure atleas
    console.log("[POST FILTERS]  postTypes after update",this.postTypes)
    this.uiStateService.updatePostTypeFilter(this.postTypes);
  }
  resetFilters(){
    if(!this.isRouteOnDashboard) {
      this.platforms={isLinkedinON:true,isGoogleON:true,isFacebookON:true,isInstagramON:true}; 
      this.postTypes={isPosted:true,isPlanned:true,isDraft:true}
    }else if(this.isRouteOnDashboard ){
      this.postTypes={isPosted:true,isPlanned:true}
    }

    const currentYear = new Date().getFullYear();
    const startDate = new Date(currentYear - 2, 0, 1); // January 1st, two years ago
    const endDate = new Date(currentYear, 11, 31); // December 31st of the current year
    this.currentDateRange={
      startDate:startDate,
      endDate:endDate
    }

    this.uiStateService.updatePostTypeFilter(this.postTypes);
    this.uiStateService.updatePlatformsFilter(this.platforms)
    this.uiStateService.updateDateRange(this.currentDateRange) 
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
